import { Link } from "react-router-dom"
import { FileText, Clipboard, ClipboardList, IndianRupee, Activity } from "lucide-react"

export default function MobileTabs() {
  return (
    <nav className="mobile-tabs">
      <ul className="mobile-tabs-list">
        {/* <li className="mobile-tab-item">
          <Link to="/reports/dashboard" className="mobile-tab-button">
            <Activity />
            <span>Dashboard</span>
          </Link>
        </li> */}
        <li className="mobile-tab-item">
          <Link to="/reports/health-reports" className="mobile-tab-button">
            <FileText />
            <span>Health Reports</span>
          </Link>
        </li>
        <li className="mobile-tab-item">
          <Link to="/reports/prescriptions" className="mobile-tab-button">
            <Clipboard />
            <span>Prescriptions</span>
          </Link>
        </li>
        {/* <li className="mobile-tab-item">
          <Link to="/reports/prescription-details" className="mobile-tab-button">
            <ClipboardList />
            <span>Details</span>
          </Link>
        </li> */}
        <li className="mobile-tab-item">
          <Link to="/reports/bills-receipts" className="mobile-tab-button">
            <IndianRupee />
            <span>Bills</span>
          </Link>
        </li>
        <li className="mobile-tab-item">
          <Link to="/reports/scanner" className="mobile-tab-button">
            <ClipboardList />
            <span>AI Scan</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}
